import { API } from "./api";

// Analytics 100% anonymes : type + slug (fiche) + jour tronqué côté serveur.
// Aucun identifiant, aucune IP, aucun lien entre événements.
export function trackEvent(type, slug) {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, slug }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}
